// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"245d9b1c","221":"5eec189e","257":"3934e9a8","288":"7ea9b06a","353":"a3df6178","367":"1179690f","507":"ae2b528e","523":"4029230a","549":"57ed69ff","561":"c59e1809","675":"da5b1382","748":"47bd78f8","749":"ce07f7ea","785":"0f3fa6e4","968":"97388f7e"}[chunkId] + ".chunk.js";
};